import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/views/layout/Layout'
import Login from '@/views/layout/Login'
import NotFound from '@/views/layout/NotFound'

Vue.use(Router)

/* 静态路由（初始化的时候即注册进去） */
const constantMap = [
    {
        path: '/',
        redirect: '/platform',
        component: Layout
    }, {
        path: '/login',
        component: Login
    }
]

export default new Router({
    // 路由切换的时候滚动到头部
    scrollBehavior: () => ({ y: 0 }),
    routes: constantMap
    // stringifyQuery: (obj) => {
    // },
    // parseQuery: (query) => {
    // }
})

/**
 * 异步路由（经过后台权限过滤之后显示的路由，从后台取过滤后的数据再注册到页面中）
 * 如果子菜单没有内容，则使用redirect跳转到children的index路由
 * title:标题
 * icon:图标
 * name:只要有name值就缓存页面(此处的name值要和组件中的name值保持一致)
 * menu:是否是菜单项
 * always:是否是始终显示的菜单项
 * cache:是否需要缓存(一般重定向的都不需要缓存)
 * 注意:index只有在一级菜单没有子菜单的时候使用
*/
export const asyncMap = [{
    path: '/404',
    meta: {},
    component: NotFound
}, {
    path: '*',
    meta: {},
    redirect: '/404'
}, {
    path: '/platform',
    component: Layout,
    redirect: '/platform/index',
    name: 'platform',
    meta: { title: '中央控制台', icon: 'fa fa-home', menu: true, always: true },
    children: [{
        path: 'index',
        name: 'platform-index',
        component: () => import('@/views/platform'),
        meta: { title: '中央控制台' }
    }]
}, {
    path: '/orgPerson',
    component: Layout,
    name: 'orgPerson',
    meta: { title: '组织人员管理', icon: 'fa fa-sitemap', menu: true },
    children: [{
        path: 'organization',
        component: () => import('@/views/orgPerson/organization'),
        name: 'orgPerson-organization',
        meta: { title: '用户组织管理', icon: 'fa fa-users', menu: true }
    }, {
        path: 'role',
        component: () => import('@/views/orgPerson/role'),
        name: 'orgPerson-role',
        meta: { title: '用户角色管理', icon: 'fa fa-user-md', menu: true }
    }]
}, {
    path: '/area',
    component: Layout,
    redirect: '/area/index',
    name: 'area',
    meta: { title: '线路台区管理', icon: 'fa fa-area-chart', menu: true },
    children: [{
        path: 'index',
        name: 'area-index',
        component: () => import('@/views/area'),
        meta: { title: '线路台区管理' }
    }]
}, {
    path: '/facility',
    component: Layout,
    redirect: '/facility/index',
    name: 'facility',
    meta: { title: '设施信息管理', icon: 'fa fa-area-chart', menu: true },
    children: [{
        path: 'index',
        name: 'facility-index',
        component: () => import('@/views/facility'),
        meta: { title: '设施信息管理' }
    }]
}, {
    path: '/key',
    component: Layout,
    redirect: '/key/index',
    name: 'key',
    meta: { title: '钥匙信息管理', icon: 'fa fa-key', menu: true },
    children: [{
        path: 'index',
        name: 'key-index',
        component: () => import('@/views/key'),
        meta: { title: '钥匙信息管理' }
    }]
}, {
    path: '/lock',
    component: Layout,
    redirect: '/lock/index',
    name: 'lock',
    meta: { title: '锁具信息管理', icon: 'fa fa-lock', menu: true },
    children: [{
        path: 'index',
        name: 'lock-index',
        component: () => import('@/views/lock'),
        meta: { title: '锁具信息管理' }
    }]
}, {
    path: '/task',
    component: Layout,
    redirect: '/task/index',
    name: 'task',
    meta: { title: '任务信息管理', icon: 'fa fa-tasks', menu: true },
    children: [{
        path: 'index',
        name: 'task-index',
        component: () => import('@/views/task'),
        meta: { title: '任务信息管理' }
    }]
}, {
    path: '/record',
    component: Layout,
    name: 'record',
    meta: { title: '数据记录管理', icon: 'fa fa-database', menu: true },
    children: [{
        path: 'locking',
        name: 'record-locking',
        component: () => import('@/views/record/locking'),
        meta: { title: '开/关锁记录', icon: 'fa fa-unlock', menu: true }
    }, {
        path: 'tasking',
        name: 'record-tasking',
        component: () => import('@/views/record/tasking'),
        meta: { title: '任务执行记录', icon: 'fa fa-thumbs-up', menu: true }
    }, {
        path: 'statistics',
        name: 'record-statistics',
        component: () => import('@/views/record/statistics'),
        meta: { title: '数据统计', icon: 'fa fa-map-o', menu: true }
    }]
}]

// 导出复制路由项
export const copyAsyncMap = JSON.parse(JSON.stringify(asyncMap))



// WEBPACK FOOTER //
// ./src/router/index.js